import styles from "./button.module.css";

const Button = ({ type,children,href,target }) => {
  return (
    <a className={`${type === "main" ? styles.main : styles.general} ${styles.button}`} href={href} target={target}>
      {children}
    </a>
  );
};

export default Button;
